import React, { useCallback, useEffect } from 'react';
import classNames from 'classnames';
import {
  Menu,
  MenuButton,
  MenuPopover,
  MenuList,
  MenuItem,
  MenuTrigger,
  Caption1 as Text
} from '@fluentui/react-components';

import { useViewSelectorStyles } from '../styles/view-selector-styles';
import { VIEWS, VIEW_STRINGS } from '../utils/const';
import { TopLocationViewSelectorProps } from '../utils/types';

const WIDE_MODE_WIDTH = 500;

export function TopLocationViewSelector({
  i18n,
  state,
  setState,
  dimensions,
}: TopLocationViewSelectorProps) {
  const styles = useViewSelectorStyles();

  useEffect(() => {
    if (!state) {
      setState({
        viewOption: VIEWS.MAP,
      });
    }
  }, [state, setState]);

  useEffect(() => {
    const isWideMode = dimensions?.width > WIDE_MODE_WIDTH;
    if (state?.isWideMode !== isWideMode) {
      setState(s => ({
        ...s,
        isWideMode,
      }));
    }
  }, [setState, state, dimensions]);

  const onViewSelected = useCallback((viewOption: VIEWS) => {
    setState(s => ({
      ...s,
      viewOption,
    }));
  }, [setState]);

  if (!state || state?.isWideMode) {
    return <></>;
  }

  return (
    <div className={classNames('ba-top-location-view-selection', styles.container)}>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <MenuButton className={classNames('select-view', styles.button)} appearance="transparent">
            <Text className={classNames('current-selection-text', styles.buttonText)}>{i18n.getString(_TL_('View:'))} {i18n.getString(VIEW_STRINGS[state.viewOption] ?? _TL_(''))}</Text>
          </MenuButton>
        </MenuTrigger>
        <MenuPopover className="view-options">
          <MenuList>
            <MenuItem className="map-view-option" onClick={() => onViewSelected(VIEWS.MAP)}>{i18n.getString(VIEW_STRINGS[VIEWS.MAP])}</MenuItem>
            <MenuItem className="table-view-option" onClick={() => onViewSelected(VIEWS.TABLE)}>{i18n.getString(VIEW_STRINGS[VIEWS.TABLE])}</MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
}

TopLocationViewSelector.defaultProps = {
  state: undefined,
};
